var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border-bottom insety-16", attrs: { id: "search" } },
    [
      _c(
        "ib-row",
        { class: { "pb-16": !_vm.$media.xl } },
        [
          _c("ib-col", { staticClass: "xl3" }, [
            _c(
              "p",
              {
                staticClass: "insety-16",
                class: {
                  "insetx-4": !_vm.$media.m,
                  "insetx-8": _vm.$media.l,
                  "insetx-16": _vm.$media.xl,
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "info", class: { "start-0": !_vm.$media.m } },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 13 13" } }, [
                      _c("path", {
                        attrs: {
                          d: "M6.5 0A6.5 6.5 0 1013 6.5 6.5 6.5 0 006.5 0z",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M6.5 2.543a.848.848 0 10.848.848.848.848 0 00-.848-.848zM5.37 5.37v.565h.565v3.674H5.37v.565h2.26v-.565h-.565V5.37z",
                          fill: "#fff",
                        },
                      }),
                    ]),
                    _vm.selectedTab === "products"
                      ? _c("span", { staticClass: "tooltext" }, [
                          _vm._v(_vm._s(_vm.$t("search_product"))),
                        ])
                      : _vm._e(),
                    _vm.selectedTab === "exchanges"
                      ? _c("span", { staticClass: "tooltext" }, [
                          _vm._v(_vm._s(_vm.$t("search_exchange"))),
                        ])
                      : _vm._e(),
                    _vm.selectedTab === "contracts"
                      ? _c("span", { staticClass: "tooltext" }, [
                          _vm._v(_vm._s(_vm.$t("search_contracts"))),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm.selectedTab === "products"
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("symbol/name")))])
                  : _vm._e(),
                _vm.selectedTab === "exchanges"
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("exchanges")))])
                  : _vm._e(),
                _vm.selectedTab === "contracts"
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("contract")))])
                  : _vm._e(),
              ]
            ),
          ]),
          _vm.selectedTab === "products" || _vm.selectedTab === "contracts"
            ? _c(
                "ib-col",
                { staticClass: "xl9 search-bar" },
                [
                  _c(
                    "ib-form",
                    { staticClass: "ticker flex-flex" },
                    [
                      _vm.selectedTab === "products"
                        ? _c("ib-field", {
                            staticClass: "ticker-field mb50",
                            attrs: {
                              placeholder: _vm.$t("optional"),
                              uppercase: "",
                              width: "100%",
                              autofocus: "",
                              align: "start",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.checkValidation(_vm.selectedProduct)
                              },
                            },
                            model: {
                              value: _vm.selectedProduct,
                              callback: function ($$v) {
                                _vm.selectedProduct = $$v
                              },
                              expression: "selectedProduct",
                            },
                          })
                        : _vm._e(),
                      _vm.selectedTab === "contracts"
                        ? _c("ib-field", {
                            staticClass: "ticker-field mb50",
                            attrs: {
                              uppercase: "",
                              width: "100%",
                              autofocus: "",
                              align: "start",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.checkValidation(_vm.selectedProduct)
                              },
                            },
                            model: {
                              value: _vm.selectedProduct,
                              callback: function ($$v) {
                                _vm.selectedProduct = $$v
                              },
                              expression: "selectedProduct",
                            },
                          })
                        : _vm._e(),
                      _vm.selectedProduct.length > 0
                        ? _c(
                            "span",
                            {
                              staticClass: "icons",
                              on: {
                                click: function ($event) {
                                  return _vm.clearField(true)
                                },
                              },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 20 20" } }, [
                                _c("path", {
                                  attrs: {
                                    d: "M10 0a10 10 0 1010 10A10.029 10.029 0 0010 0z",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M14.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4L8.6 10 5.1 6.5l1.4-1.4L10 8.6l3.5-3.5 1.4 1.4-3.5 3.5z",
                                    fill: "#fff",
                                  },
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.selectedProduct.length === 0
                        ? _c(
                            "button",
                            {
                              staticClass: "icons",
                              on: { click: _vm.getResults },
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                                _c("path", {
                                  attrs: {
                                    d: "M21 3C11.6 3 4 10.6 4 20a16.99 16.99 0 0 0 26.1 14.34l12.27 12.28 4.26-4.24-12.13-12.1A16.99 16.99 0 0 0 21 3zm0 4c7.2 0 13 5.8 13 13s-5.8 13-13 13S8 27.2 8 20 13.8 7 21 7z",
                                  },
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.selectedProduct.length
                    ? _c("div", { class: { results: _vm.isActive } }, [
                        _c(
                          "div",
                          [
                            _vm._l(
                              _vm.productSearchResults,
                              function (result, index) {
                                return _vm.showResults
                                  ? _c(
                                      "div",
                                      {
                                        key: result.conid,
                                        staticClass:
                                          "products_dropdown insety-8 insetx-16",
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewDetails(
                                              result.companyHeader,
                                              result.conid,
                                              result.conid,
                                              "all"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "product-symbol" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(result.symbol)),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "pointer product-item",
                                            class: {
                                              "insetx-32": _vm.$media.m,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "item bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(result.companyHeader) +
                                                    " - " +
                                                    _vm._s(result.description)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e()
                              }
                            ),
                            _vm.showResults &&
                            _vm.moreResults.length > 5 &&
                            _vm.productSearchResults.length < 6
                              ? _c(
                                  "ib-button",
                                  {
                                    staticClass:
                                      "more-results pointer fg-accent",
                                    on: { click: _vm.showMoreProducts },
                                  },
                                  [_c("span", [_vm._v("More Results")])]
                                )
                              : _vm._e(),
                            _vm.noSuggestions
                              ? _c("div", [
                                  _c("p", { staticClass: "suggestions" }, [
                                    _vm._v(
                                      'No results for "' +
                                        _vm._s(_vm.selectedProduct) +
                                        '"'
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.selectedTab === "exchanges"
            ? _c("ib-col", { staticClass: "xl9 search-bar" }, [
                _c(
                  "div",
                  { staticClass: "ticker flex-flex" },
                  [
                    _c("ib-field", {
                      staticClass: "ticker-field mb50",
                      attrs: {
                        placeholder: _vm.$t("optional"),
                        uppercase: "",
                        width: "100%",
                        autofocus: "",
                        align: "start",
                      },
                      model: {
                        value: _vm.selectedExchange,
                        callback: function ($$v) {
                          _vm.selectedExchange = $$v
                        },
                        expression: "selectedExchange",
                      },
                    }),
                    _vm.selectedExchange.length > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "icons",
                            on: {
                              click: function ($event) {
                                return _vm.clearField(true)
                              },
                            },
                          },
                          [
                            _c("svg", { attrs: { viewBox: "0 0 20 20" } }, [
                              _c("path", {
                                attrs: {
                                  d: "M10 0a10 10 0 1010 10A10.029 10.029 0 0010 0z",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M14.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4L8.6 10 5.1 6.5l1.4-1.4L10 8.6l3.5-3.5 1.4 1.4-3.5 3.5z",
                                  fill: "#fff",
                                },
                              }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedExchange.length === 0
                      ? _c(
                          "button",
                          {
                            staticClass: "icons",
                            on: { click: _vm.getResults },
                          },
                          [
                            _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                              _c("path", {
                                attrs: {
                                  d: "M21 3C11.6 3 4 10.6 4 20a16.99 16.99 0 0 0 26.1 14.34l12.27 12.28 4.26-4.24-12.13-12.1A16.99 16.99 0 0 0 21 3zm0 4c7.2 0 13 5.8 13 13s-5.8 13-13 13S8 27.2 8 20 13.8 7 21 7z",
                                },
                              }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.showResults
                  ? _c(
                      "div",
                      { class: { results: _vm.isActive } },
                      _vm._l(_vm.exchangeSearchResults, function (result) {
                        return _c(
                          "li",
                          {
                            key: result.symbol,
                            on: {
                              click: function ($event) {
                                return _vm.selectExchange(result)
                              },
                            },
                          },
                          [_vm._v(_vm._s(result))]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("SearchProducts", { ref: "searchProducts" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }